import {set} from 'vue';

import Routing from 'routing';
import request from '../utils/request';

const DATA = 'DATA';
const SET_GIFTS = 'SET_GIFTS';

const state = {
    gifts: []
};

const actions = {
    init(){
        this.dispatch('gift/getGifts');
    },

    async getGifts({commit}) {
        try {
            const data = await request(Routing.generate('site_gift_list'));
            commit(DATA, data.data.gifts || []);
        } catch (err) {
            console.error(err);
        }

    },

    setGifts({commit}, gifts) {
        commit(SET_GIFTS, gifts || []);
    },
};

const mutations = {
    [DATA](state, data) {
        set(state, 'gifts', data);
    },
    [SET_GIFTS](state, data) {
        set(state, 'gifts', data);
    },
};

const Store = {
    namespaced: true,
    state,
    actions,
    mutations
};

export default Store;



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/modules/gift.js